import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { root } from "./styles";

export const Error403 = (props: any): any => {
  const { t } = useTranslation();

  return (
    <Box sx={root}>
      <Typography variant="h1">{t("error.forbiddenCode").valueOf()}</Typography>
      <Typography variant="h3">
        {t("error.forbiddenTitle").valueOf()}
      </Typography>
      <Typography variant="body1">
        {t("error.forbiddenDescription").valueOf()}
      </Typography>
    </Box>
  );
};

export default Error403;
